import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import App from "./App";
import { getPaymentLinkRedirect } from "./utils/paymentLinks";
const container = document.getElementById("root");
if (!container) {
    throw new Error("Root element not found");
}
// Payment links redirect before the app mounts, so a buyer never waits for Auth0 or sees the login screen
const paymentLinkRedirect = getPaymentLinkRedirect(window.location.pathname, window.location.search);
if (paymentLinkRedirect) {
    window.location.replace(paymentLinkRedirect);
}
else {
    createRoot(container).render(_jsx(App, {}));
}
